import { PipeTransform, Pipe } from "@angular/core";


@Pipe({
    name: 'filterStats'
})
export class StatsFilter implements PipeTransform {
    transform(stats: any[], searchText: string, property: string = 'type'): any {
        return stats.filter(stat => stat._id[property] === searchText);
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/core/pipes/filterStats.pipe.ts